module.exports = __webpack_public_path__ + "gateway.60938849e4d2822e371ab5ec2fa76827.svg";